export default __webpack_public_path__ + "static/const-ten-a4087f133dac997f64553410b112d1bb.png";